howspace.evaluation = (() => {
    'use strict';

    const saveGradingResult = function (gradingFieldInput) {
        return new Promise((resolve, reject) => {
            const gradingField = gradingFieldInput.closest('.grading-field');

            if (gradingFieldInput.val().trim() === '' && !gradingField.data('grading-result-id')) {
                // Value is empty and there is no answer yet, do nothing.
                resolve();
                return;
            }

            const timeoutId = gradingField.data('hide-icons-timeout-id');
            if (timeoutId) {
                clearTimeout(timeoutId);
                gradingField.removeDataAndAttr('hide-icons-timeout-id');
            }

            gradingField.find('.grading-field-icon').addClass('d-none');
            gradingField.find('.grading-field-icon.saving-icon').removeClass('d-none');

            let url = real.baseUri + '/api';
            if (gradingField.data('grading-result-id')) {
                // Update existing result.
                url += '/gradingresult/' + gradingField.data('grading-result-id');
            } else {
                // No result exists yet, create a new one.
                url += '/gradingresults';
            }

            const successFn = function (response) {
                $('.user[data-user-id="' + response.gradingresult.user + '"] .grading-field[data-grading-field-id="' + gradingField.data('grading-field-id') + '"]').each(function () {
                    const gradingField = $(this);

                    if (response.gradingresult.deleted_at === null) {
                        // Grading result was created or updated.
                        gradingField.dataAndAttr('grading-result-id', response.gradingresult.id);
                        gradingField.find('input,select,textarea').val(response.gradingresult.value);
                    } else {
                        // Grading result was deleted.
                        gradingField.removeDataAndAttr('grading-result-id');
                        gradingField.find('input,select,textarea').val(null);
                    }

                    gradingField.find('.grading-field-icon').addClass('d-none');
                    gradingField.find('.grading-field-icon.saved-icon').removeClass('d-none');

                    if (gradingFieldInput.is('select')) {
                        const gradingFieldClass = gradingFieldInput.find('option:selected').data('select-class');
                        gradingField.find('select').removeClass('is-passed').removeClass('is-failed').addClass(gradingFieldClass);
                    } else if (gradingFieldInput.is('input[type="number"]')) {
                        const passingValue = gradingFieldInput.data('passing-value');
                        const value = gradingFieldInput.val();
                        let gradingFieldClass = '';
                        if (value !== '' && parseFloat(value) >= parseFloat(passingValue)) {
                            gradingFieldClass = 'is-passed';
                        } else if (value !== '' && parseFloat(value) < parseFloat(passingValue)) {
                            gradingFieldClass = 'is-failed';
                        }
                        gradingField.find('input[type="number"]').removeClass('is-passed').removeClass('is-failed').addClass(gradingFieldClass);
                    }

                    gradingField.dataAndAttr('hide-icons-timeout-id', setTimeout(function () {
                        gradingField.find('.grading-field-icon:not(.d-none)').velocity('fadeOut', {
                            duration: 'fast',
                            complete: function () {
                                $(this).removeAttr('style').addClass('d-none');
                            }
                        });
                    }, 1000));
                });

                resolve(response);
            };

            const errorFn = function (response) {
                gradingField.find('.grading-field-icon').addClass('d-none');
                gradingField.find('.grading-field-icon.error-icon').removeClass('d-none');

                reject(response);
            };

            if (gradingFieldInput.val().trim() === '' && gradingField.data('grading-result-id')) {
                // Delete grading result.
                real.ajax.json(url, {
                    type: 'DELETE',
                    success: successFn,
                    error: errorFn
                });
            } else {
                // Create or update grading result.
                const dataPayload = {
                    gradingfield: gradingField.data('grading-field-id'),
                    user: gradingField.closest('.user').data('user-id'),
                    value: gradingFieldInput.val()
                };

                real.ajax.json(url, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: successFn,
                    error: errorFn
                });
            }
        });
    };

    return {
        saveGradingResult: saveGradingResult
    };
})();
